class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia(this.openedBy, true);
  }

  scrollToThumb(thumb) {
    thumb.parentElement.scrollTo({
      top: Number(thumb.dataset.index * thumb.offsetHeight),
    });

    thumb.click();
    this.swiperSlideTo(thumb);

    console.log("ss");
  }

  swiperSlideTo(element) {
    if (this.swiper) {
      let index = element.getAttribute("data-index");
      this.swiper.slideTo(
        Number(index),
        Math.abs(this.swiper.activeIndex - index) * 300,
        false
      );
    }
  }

  showActiveMedia(element, scrollThumbs) {
    const activeMediaId = element.getAttribute("data-media-id");
    const parent = this.querySelector(
      `.js-product-gallery-media[data-media-id="${activeMediaId}"]`
    ).parentElement;
    const video = parent.querySelector("video, .js-vimeo, .js-youtube");

    pauseAllMedia();

    this.playVideo(video);

    // this.querySelectorAll('.js-product-gallery-media[data-media-id]').forEach(
    //   (media) => {
    //     media.parentElement.classList.add('hidden');
    //   },
    // );

    parent.classList.remove("hidden");
    this.querySelectorAll("[data-thumb-id]").forEach((thumb) => {
      thumb.classList.toggle(
        "is-active",
        thumb.dataset.thumbId === activeMediaId
      );

      thumb.classList.contains("is-active") &&
        scrollThumbs &&
        this.scrollToThumb(thumb);
    });
  }

  playVideo(video) {
    if (!video) return;
    if (video.classList.contains("js-vimeo")) {
      video.contentWindow.postMessage('{"method":"play"}', "*");
    } else if (video.classList.contains("js-youtube")) {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "playVideo" + '","args":""}',
        "*"
      );
    } else {
      video.play();
    }
  }

  handleSlideChange(swiper) {
    const thumb = this.querySelector(
      `[data-index="${this.swiper.activeIndex}"]`
    );
    if (!thumb) return;
    if (thumb.classList.contains("is-active")) return;
    this.scrollToThumb(thumb);
  }

  connectedCallback() {
    this.thumbs = this.querySelector("[data-thumbs]");
    this.scrollWrapper = this.thumbs;
    this.querySelectorAll("[data-thumb-id]").forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        e.preventDefault();
        this.showActiveMedia(thumb, false);
        this.swiperSlideTo(thumb);
      });
    });

    this.slider = this.querySelector("[data-slider]");

    if (!this.slider) return;

    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      navigation: {
        prevEl: this.querySelector(".swiper-arrow--prev"),
        nextEl: this.querySelector(".swiper-arrow--next"),
      },
      keyboard: {
        enabled: true,
      },
    });

    this.swiper.on("slideChange", this.handleSlideChange.bind(this));
  }
}

customElements.define("product-modal", ProductModal);
